import { actionTypes } from "../actions/route";
import { updateStopInStopList } from "../../models/route";

const initialState = {
  currentUserLock: false,
  routeDetail: null,
  originalRouteDetail: null,
  scheduleRequired: false,
  transferRouteId: null,
  transferFromRouteId: null,
  requestOrder: 0,
  isSubmitting: false,
  saveRouteEnable: false,
  initialDowngradeAttempts: null,
};

const route = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_CURRENT_USER_LOCK:
      return {
        ...state,
        currentUserLock: payload,
      };
    case actionTypes.FETCH_ROUTE_DETAIL_COMPLETE:
      return {
        ...state,
        routeDetail: payload,
        originalRouteDetail: payload,
        initialDowngradeAttempts: null,
      };
    case actionTypes.CLEAR_ROUTE_DETAIL:
      return {
        ...state,
        routeDetail: null,
        originalRouteDetail: null,
        scheduleRequired: false,
        initialDowngradeAttempts: null,
      };
    case actionTypes.UPDATE_STOP: {
      const { stop: stops } = state.routeDetail;
      const updatedStops = updateStopInStopList(stops, payload);

      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          stop: updatedStops,
        },
      };
    }
    case actionTypes.ADD_STOP: {
      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          stop: [...state.routeDetail.stop, payload],
        },
      };
    }
    case actionTypes.SET_STOPS:
      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          stop: payload,
        },
      };
    case actionTypes.UPDATE_ROUTE_STATUS:
      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          status: payload,
        },
      };
    case actionTypes.SET_SCHEDULE_REQUIRED:
      return {
        ...state,
        scheduleRequired: payload,
      };
    case actionTypes.SET_SAVE_ROUTE_ENABLE:
      return {
        ...state,
        saveRouteEnable: payload,
      };
    case actionTypes.SET_ROUTE_DETAIL:
      return {
        ...state,
        routeDetail: payload,
      };
    case actionTypes.SET_ROUTE_CHECKSUM:
      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          checksum: payload,
        },
      };
    case actionTypes.SET_TRANSFERRED_STOP:
      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          transferredStop: payload,
        },
      };
    case actionTypes.SET_REQUESTS:
      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          request: payload,
        },
      };
    case actionTypes.REQUEST_SUBMITTING_STATUS:
      return {
        ...state,
        isSubmitting: payload,
      };
    case actionTypes.SET_TRANSFER_ROUTE_ID:
      return {
        ...state,
        transferRouteId: payload,
      };
    case actionTypes.SET_TRANSFER_FROM_ROUTE_ID:
      return {
        ...state,
        transferFromRouteId: payload,
      };
    case actionTypes.SET_ORIGINAL_STOPS_DATA:
      return {
        ...state,
        routeDetail: {
          ...state.routeDetail,
          originalStopsData: payload,
        },
      };
    case actionTypes.SET_INITIAL_DOWNGRADE_ATTEMPTS:
      return {
        ...state,
        initialDowngradeAttempts: payload,
      };
    case actionTypes.INCREMENT_REQUEST_ORDER:
      return {
        ...state,
        requestOrder: state.requestOrder + 1,
      };
    case actionTypes.RESET_REQUEST_ORDER:
      return {
        ...state,
        requestOrder: initialState.requestOrder,
      };
    default:
      return state;
  }
};

export default route;
